import React from 'react'
import styled from 'styled-components'

const Err = styled.div`
  margin-top: 2px;
  width: auto;
  line-height: 20px;
  .errShow {
    height: 20px;
  }
`
const Text = styled.div`
  height: 0px;
  overflow: hidden;
  transition: height 0.2s linear;
  color: ${({ theme }) => theme.bsText13};
  font-size: 12px;
`

export default function LaunchErr({errShow, text}: {errShow: boolean, text: string}) {
  return (
    <>
      <Err>
        <Text className={errShow ? 'errShow' : ''}>{text}</Text>
      </Err>
    </>
  )
}
